import React from 'react';
import UserFormPage from './UserFormPage';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const UserEdit: React.FC<ShowAlerts> = () => <UserFormPage mode="edit" />;

export default UserEdit;
